<svg
  class="orbi-text-dot"
  [style.width.px]="size"
  [style.height.px]="size"
  viewBox="0 0 26 26"
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  aria-hidden="true"
>
  <g class="orbi-text-dot__body">
    <circle cx="13" cy="13" r="12" stroke="currentColor" stroke-width="2" />
    <g class="orbi-text-dot__eyes">
      <g class="orbi-text-dot__lids">
        <path
          d="M10.4834 6.70996C12.1046 6.70996 13.4189 8.02428 13.4189 9.64551V13.8389C13.4189 15.46 12.1046 16.7744 10.4834 16.7744C8.86245 16.7742 7.54891 15.4599 7.54883 13.8389V9.64551C7.54883 8.02444 8.86239 6.71022 10.4834 6.70996ZM9.64551 9.22559C8.95086 9.22559 8.38697 9.78881 8.38672 10.4834C8.38672 11.1782 8.9507 11.7422 9.64551 11.7422C10.3402 11.742 10.9033 11.1781 10.9033 10.4834C10.9031 9.78892 10.34 9.22577 9.64551 9.22559Z"
          fill="currentColor"
        />
        <path
          d="M18.0322 6.70996C19.6535 6.70996 20.9678 8.02428 20.9678 9.64551V13.8389C20.9677 15.46 19.6534 16.7744 18.0322 16.7744C16.4111 16.7744 15.0968 15.46 15.0967 13.8389V9.64551C15.0967 8.02429 16.411 6.70998 18.0322 6.70996ZM17.1934 9.22559C16.4988 9.22569 15.9358 9.78887 15.9355 10.4834C15.9355 11.1781 16.4986 11.7421 17.1934 11.7422C17.8882 11.7422 18.4512 11.1782 18.4512 10.4834C18.4509 9.78881 17.888 9.22559 17.1934 9.22559Z"
          fill="currentColor"
        />
      </g>
    </g>
  </g>
</svg>
